export default __webpack_public_path__ + "static/media/summernote.4b3ca613.eot";